import React, { useEffect, useState }  from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import CustomFunction from '../customFuction';
import HomeInactive from '../../Views/TuneUp/HomeInactive.svg';
import HomeActiveIcon from '../../Views/TuneUp/HomeActive.svg';
import OrderIcon from '../../Views/TuneUp/OrdersInactive.svg';
import OrderActive from '../../Views/TuneUp/OrdersActive.svg';
import ProfileIcon from '../../Views/TuneUp/ProfileInactive.svg';
import ProfileActiveIcon from '../../Views/TuneUp/ProfileActive.svg';
import './footer.scss'

const LoggedOutView = props => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const customStyles = {
    content: {
      top: '40%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '30px 15px',
      width: '90%'
    },
  };

  const handleProtectedNavigation = (path) => {
      if (!CustomFunction.isAuthenticated()) {
        setShowLoginModal(true);
      } else {
        navigate(path);
      }
    };
  
    const handleLoginRedirect = () => {
      navigate('/signin');
    };
  
    const path = location.pathname;
    const handleCloseModal = () => {
      setShowLoginModal(false);
    };

  if (!props.currentUser && location.pathname !== '/') {
    return (
      <>
        <Modal isOpen={showLoginModal} onRequestClose={handleCloseModal} style={customStyles} shouldCloseOnOverlayClick={false} shouldCloseOnEsc={false}>
          <h3 style={{ textAlign: 'center' }}>You will be able to check once you login</h3>
          <div style={{ marginTop: '20px', display: 'flex' }}>
            <button className="btn" onClick={handleLoginRedirect} style={{ marginRight: '10px' }}>
              Sign In
            </button>
            <button className="btn" style={{ background: 'transparent', color: '#ff5f07' }} onClick={handleCloseModal}>Close</button>
          </div>
        </Modal>
        <div className='footer-main-wrp-in'>
          <div className="footer-lst">
            <div className="footer-lst-in">
              <div className="footer-item">
                <NavLink to="/home" className={({ isActive }) => (isActive ? 'footer-in active' : 'footer-in')}>
                  <span className='footer-link-in'>
                    <img className='svg-icon' src={ path.includes('/home') || path.includes('/booking') || path.includes('/services/') ? HomeActiveIcon : HomeInactive} />
                  </span>
                  <span className='footer-txt'>Home</span>
                </NavLink>
              </div>
              <div className="footer-item">
                <div onClick={() => handleProtectedNavigation('/order-history')} className={( path === '/order-history' ? 'footer-in active' : 'footer-in' )} style={{ cursor: 'pointer' }}>
                  <span className='footer-link-in'>
                    <img className='svg-icon' src={path.includes('/order') ? OrderActive : OrderIcon} alt="Orders" />
                  </span>
                  <span className='footer-txt'>Orders</span>
                </div>
              </div>
              <div className="footer-item">
                <div onClick={() => handleProtectedNavigation('/profile')} className={( path === '/profile' ? 'footer-in active' : 'footer-in' )} style={{ cursor: 'pointer' }}>
                  <span className='footer-link-in'>
                    <img className='svg-icon' src={ path.includes('/profile') ? ProfileActiveIcon : ProfileIcon} alt="Orders" />
                  </span>
                  <span className='footer-txt'>Profile</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  return null;
};

class Footer extends React.Component {
  render() {
    return (
      <footer className='footer-main-wrp'>
        <LoggedOutView currentUser={this.props.currentUser} />
      </footer>
    );
  }
}

export default Footer;